import React, { useRef } from "react";

import { Form } from "devextreme-react";
import { SimpleItem } from "devextreme-react/form";
import { Label } from "devextreme-react/chart";
import ButtonOKCancel from "./ButtonOKCancel";
import { useDispatch } from "react-redux";
import { updateChartTitle } from "./Redux/chartTitleSlice";

export default function ChartTitleContainer(props) {
  const { chartTitlePopupRef } = props;

  const formRef = useRef(null);

  const dispatch = useDispatch();

  const chartTitleEditorOptions = {
    value: null,
  };

  const onCancelClick = (e) => {
    chartTitlePopupRef.current.instance.hide();
  };

  const onOkClick = (e) => {
    dispatch(
      updateChartTitle(formRef.current.instance.option("formData").chartTitle)
    );

    chartTitlePopupRef.current.instance.hide();
  };

  return (
    <React.Fragment>
      <Form ref={formRef}>
        <SimpleItem
          dataField="chartTitle"
          editorType="dxTextBox"
          editorOptions={chartTitleEditorOptions}
        >
          <Label text="제목" />
        </SimpleItem>
      </Form>
      <ButtonOKCancel onCancelClick={onCancelClick} onOkClick={onOkClick} />
    </React.Fragment>
  );
}
